<template>
  <Record>
    <div>
      <Row>
        <Column :xl="3" :xs="6">
          <Set icon="mail" :label="$t('recipient')">
            {{ mail.to }}
          </Set>
        </Column>
        <Column :xl="3" :xs="6">
          <Set icon="lock" :label="$t('subject')">
            {{ mail.subject }}
          </Set>
        </Column>
        <Column :xl="3" :xs="6">
          <Set icon="mail" :label="$t('status')">
            {{ mail.isSent ? $t('sent') : $t('sentNot') }}
          </Set>
        </Column>
        <Column :xl="3" :xs="6">
          <Set icon="clock" :label="$t('date')">
            {{ $d(mail.createdAt, 'short') }}
          </Set>
        </Column>
      </Row>
      <div v-if="isOpen">
        <pre>{{ mail.text }}</pre>
      </div>
    </div>
    <div slot="actions">
      <Btn
        class="ib sm inv"
        @click="isOpen = !isOpen">
        {{ isOpen ? $t('close') : $t('open') }}
      </Btn>
    </div>
  </Record>
</template>

<script>
import Record from '@components/Record'
import Set from '@components/Set'

export default {
  components: { Record, Set },
  props: {
    mail: Object,
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "close": "Close",
    "date": "Date",
    "open": "Open",
    "recipient": "Recipient",
    "sent": "Sent",
    "sentNot": "Not sent",
    "status": "Status",
    "subject": "Subject"
  }
}
</i18n>
